/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdAlertUpdateResponse {
    getFixupPrototypeFunction() { return ThresholdAlertUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<ThresholdAlertUpdateResponse>): ThresholdAlertUpdateResponse {
        let obj = Object.assign(new ThresholdAlertUpdateResponse(), model);
        ThresholdAlertUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdAlertUpdateResponse>): ThresholdAlertUpdateResponse {
        if (!model) return null;
        return ThresholdAlertUpdateResponse.newInstance(<ThresholdAlertUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdAlertUpdateResponse) {
        if (!obj) return;

        models.ThresholdAlertUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdAlertUpdateResponse): boolean {
        Object.setPrototypeOf(obj, ThresholdAlertUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold_details) {
            for (let val of this.threshold_details) {
                models.ThresholdAlertDetailsModel.fixupPrototype(val);
            }
        }
    }

    threshold_details: Array<models.ThresholdAlertDetailsModel>;

}
